import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["icon"];
// @ts-expect-error untyped module
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useState } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { useAppContext } from '../../context/AppContext';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { INITIAL_POPULAR_COUNT, INITIAL_POPULAR_INDUSTRY_COUNT, POPULAR_INDUSTRY_SLUGS, POPULAR_SERVICE_SLUGS } from '../constants/find-partner-match';
import { useGetPartnerCount } from './useGetPartnerCount';
export function useFindPartnerMatch(onClose) {
  const [step, setStep] = useState(1);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [requireOfficeInCountry, setRequireOfficeInCountry] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const {
    PROFILE_CATALOG_SERVICES: serviceFilter,
    PROFILE_INDUSTRIES: industryFilter,
    PROFILE_LOCATION_COUNTRY: countryFilter
  } = useFilterConfig({
    productTypes: ['SOLUTIONS_PARTNER_PROFILE']
  });
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  const appContext = useAppContext();
  const toSelectOptions = options => options.map(_ref => {
    let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return rest;
  });
  const serviceOptions = serviceFilter !== null && serviceFilter !== void 0 && serviceFilter.options ? toSelectOptions(serviceFilter.options) : [];
  const partnerCount = useGetPartnerCount(selectedServices, selectedIndustries, selectedCountry, requireOfficeInCountry, selectedLanguages);
  const allPopularServices = !(serviceFilter !== null && serviceFilter !== void 0 && serviceFilter.options) ? [] : POPULAR_SERVICE_SLUGS.map(slug => serviceFilter.options.find(o => o.slug === slug)).filter(option => !!option && !selectedServices.includes(option.value));
  const popularServices = showMore ? allPopularServices : allPopularServices.slice(0, INITIAL_POPULAR_COUNT);
  const industryOptions = industryFilter !== null && industryFilter !== void 0 && industryFilter.options ? toSelectOptions(industryFilter.options) : [];
  const popularIndustries = !(industryFilter !== null && industryFilter !== void 0 && industryFilter.options) ? [] : POPULAR_INDUSTRY_SLUGS.map(slug => industryFilter.options.find(o => o.slug === slug)).filter(option => !!option && !selectedIndustries.includes(option.value)).slice(0, INITIAL_POPULAR_INDUSTRY_COUNT);
  const countryOptions = countryFilter !== null && countryFilter !== void 0 && countryFilter.options ? toSelectOptions(countryFilter.options) : [];
  const navigateToResults = (industries, country, languages, requireOffice) => {
    if (selectedServices.length === 0) return;
    const urlParams = new URLSearchParams(location.search);
    urlParams.delete(`${KEY_PREFIX}PROFILE_CATALOG_SERVICES`);
    selectedServices.forEach(service => {
      urlParams.append(`${KEY_PREFIX}PROFILE_CATALOG_SERVICES`, service);
    });
    urlParams.delete(`${KEY_PREFIX}PROFILE_INDUSTRIES`);
    industries.forEach(industry => {
      urlParams.append(`${KEY_PREFIX}PROFILE_INDUSTRIES`, industry);
    });
    urlParams.delete(`${KEY_PREFIX}PROFILE_LOCATION_COUNTRY`);
    if (country) {
      urlParams.set(`${KEY_PREFIX}PROFILE_LOCATION_COUNTRY`, country);
    }
    urlParams.delete(`${KEY_PREFIX}PROFILE_OFFICE_LOCATION`);
    if (requireOffice && country) {
      urlParams.set(`${KEY_PREFIX}PROFILE_OFFICE_LOCATION`, country);
    }
    urlParams.delete(`${KEY_PREFIX}PROFILE_LANGUAGES`);
    languages.forEach(language => {
      urlParams.append(`${KEY_PREFIX}PROFILE_LANGUAGES`, language);
    });
    history.push({
      pathname: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
      search: `?${urlParams.toString()}`
    });
    onClose();
  };
  const handleNext = () => {
    if (step === 1) {
      if (selectedServices.length === 0) return;
      setStep(2);
    } else if (step === 2) {
      setStep(3);
    } else if (step === 3) {
      setStep(4);
    } else {
      navigateToResults(selectedIndustries, selectedCountry, selectedLanguages, requireOfficeInCountry);
      if (clientLoaded && appContext === 'app') {
        // locked-nav-item survey
        loadSurvey(1467, 'CSAT');
      }
    }
  };
  const handleSkip = () => {
    if (step === 2) {
      setSelectedIndustries([]);
      setStep(3);
    } else if (step === 3) {
      setSelectedCountry(null);
      setRequireOfficeInCountry(false);
      setStep(4);
    } else if (step === 4) {
      navigateToResults(selectedIndustries, selectedCountry, [], requireOfficeInCountry);
      if (clientLoaded && appContext === 'app') {
        // locked-nav-item survey
        loadSurvey(1467, 'CSAT');
      }
    }
  };
  const handleBack = () => {
    if (step === 2) {
      setStep(1);
    } else if (step === 3) {
      setStep(2);
    } else if (step === 4) {
      setStep(3);
    }
  };
  return {
    step,
    setStep,
    selectedServices,
    setSelectedServices,
    selectedIndustries,
    setSelectedIndustries,
    selectedCountry,
    setSelectedCountry,
    requireOfficeInCountry,
    setRequireOfficeInCountry,
    selectedLanguages,
    setSelectedLanguages,
    showMore,
    setShowMore,
    partnerCount,
    serviceOptions,
    allPopularServices,
    popularServices,
    industryOptions,
    popularIndustries,
    countryOptions,
    handleNext,
    handleSkip,
    handleBack
  };
}